module.exports = __webpack_public_path__ + "static/media/027.da4b909f.jpg";